import { Instagram, Mail } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Button } from '@city-sage/aurum-avis-labs-components';
import { useTranslation } from 'react-i18next';
import { requestConsentPreferences } from '../../lib/consent';

export interface FooterProps {
  // Add any props if needed in the future
}

export function Footer(props: FooterProps) {
  const { t } = useTranslation();

  return (
    <footer className="bg-white border-t border-gray-100 mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h3 className="text-base font-semibold mb-2">{t('common.footer.about.title')}</h3>
            <p className="text-xs text-gray-600">
              {t('common.footer.about.description')}
            </p>
          </div>
          <div>
            <h3 className="text-base font-semibold mb-2">{t('common.footer.quickLinks.title')}</h3>
            <ul className="space-y-1">
              <li>
                <Button size="sm" variant="link" asChild className="h-6 p-0">
                  <a
                    href="https://www.aurum-avis-labs.ch"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Aurum Avis Labs Website
                  </a>
                </Button>
              </li>
              <li>
                <Button size="sm" variant="link" asChild className="h-6 p-0">
                  <Link to="/help">
                    FAQ
                  </Link>
                </Button>
              </li>
              <li>
                <Button size="sm" variant="link" asChild className="h-6 p-0">
                  <Link to="/terms">
                    {t('common.footer.quickLinks.terms')}
                  </Link>
                </Button>
              </li>
              <li>
                <Button size="sm" variant="link" asChild className="h-6 p-0">
                  <Link to="/privacy">
                    {t('common.footer.quickLinks.privacy')}
                  </Link>
                </Button>
              </li>
              <li>
                <Button
                  type="button"
                  size="sm"
                  variant="link"
                  className="h-6 p-0"
                  onClick={() => requestConsentPreferences()}
                >
                  {t('common.footer.quickLinks.cookies')}
                </Button>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-base font-semibold mb-2">{t('common.footer.contact.title')}</h3>
            <div className="space-y-1 flex flex-col items-start">
              <div className="flex gap-2 ">
                <Mail className="w-4 h-4 mr-1 text-primary" />
                <span className="text-xs text-primary">citysage@aurum-avis-labs.ch</span>
              </div>
              <Button size="sm" variant="link" asChild className="h-6 p-0">
                <a
                  href="https://www.instagram.com/aurumavis"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center"
                >
                  <Instagram className="w-4 h-4 mr-1" />
                  <span className="text-xs">{t('common.footer.contact.followInstagram')}</span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 py-4 border-t border-gray-200 text-center">
        <p className="text-xs text-gray-600">
          {t('common.footer.copyright', { year: new Date().getFullYear() })}
        </p>
      </div>
  </footer>
  );
}
